// extracted by mini-css-extract-plugin
export var readonly = "_j3-1";
export var star = "_j3-0";